/**
 * Mapeo `code` (del backend) → mensaje terminal en castellano.
 *
 * El backend devuelve `error` legible y `code` máquina. Este mapa nos
 * permite reescribir el texto al estilo del terminal CRT (mayúsculas,
 * sin tildes innecesarias, mensaje denso) sin depender de cómo lo
 * formuló el endpoint. Si llega un `code` desconocido, fallback al
 * `error` recibido o a un mensaje genérico.
 */

const MAP: Record<string, string> = {
  // Comunes
  bad_json: 'TRANSMISIÓN MALFORMADA. INTÉNTALO DE NUEVO.',
  network_error: 'SIN CONEXIÓN CON EL SERVIDOR. VERIFICA TU RED.',
  unknown_error: 'ERROR DESCONOCIDO. INTÉNTALO MÁS TARDE.',

  // Login
  invalid_credentials: 'ACCESO DENEGADO. CALLSIGN O PASSWORD INCORRECTOS.',
  email_not_verified:
    'ACCESO DENEGADO. EMAIL NO VERIFICADO — REVISA TU BANDEJA.',
  account_inactive:
    'CUENTA INACTIVA. CONTACTA CON UN ADMINISTRADOR DEL ESCUADRÓN.',

  // Register
  callsign: 'CALLSIGN INVÁLIDO. 3-16 CARACTERES, LETRAS/NÚMEROS/_/-',
  email: 'EMAIL INVÁLIDO. REVISA EL FORMATO.',
  password: 'PASSWORD DEMASIADO CORTA. MÍNIMO 10 CARACTERES.',
  callsign_taken: 'CALLSIGN YA REGISTRADO. ELIGE OTRO.',
  email_taken: 'EMAIL YA REGISTRADO. USA OTRO O RECUPERA TU PASSWORD.',
  cfTurnstileResponse:
    'VERIFICACIÓN ANTI-BOT NO COMPLETADA. RESUELVE EL RETO Y REINTENTA.',
  turnstile_failed: 'VERIFICACIÓN ANTI-BOT FALLIDA. REINTENTA EL RETO.',
  turnstile_unavailable:
    'VERIFICACIÓN ANTI-BOT NO DISPONIBLE. INTÉNTALO MÁS TARDE.',

  // Sesión
  not_authenticated: 'NO HAS INICIADO SESIÓN.',

  // Rate limiting (Fase 3g)
  rate_limited:
    'DEMASIADOS INTENTOS. ESPERA UNOS MINUTOS Y VUELVE A INTENTARLO.',

  // Otros mensajes específicos del flujo CRT
  passwords_mismatch: 'LAS PASSWORDS NO COINCIDEN. INTÉNTALO DE NUEVO.',

  // Verificación de email y recuperación (Fase 3b2)
  invalid_token: 'ENLACE NO VÁLIDO. SOLICITA UNO NUEVO.',
  token_expired: 'EL ENLACE HA CADUCADO. SOLICITA UNO NUEVO.',
  token_used: 'ESTE ENLACE YA SE HA USADO.',
};

/** Devuelve el mensaje del terminal asociado a `code`. */
export function messageFor(code: string, fallback?: string): string {
  return MAP[code] ?? fallback?.toUpperCase() ?? 'ERROR.';
}
